<template>
	<div data-test-id="modal-order-detail-ec-code">
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper
					title="Retry Redeem EC-Code?"
					@onClose="close"
				/>
			</template>
			<template #default>
				<p>Updating the EC-code status will change the order status to 'Preparing' and this action cannot be undone.</p>
				<CTextarea
					v-model.trim="message"
					placeholder="Please add remark"
					rows="3"
				/>
			</template>
			<template #footer>
				<CButton
					color="tertiary"
					class="transparent mr-3"
					:disabled="isSubmitting"
					@click="close"
				>
					Cancel
				</CButton>
				<CButton
					data-test-id="submit-button"
					color="primary"
					class="transparent"
					:disabled="!message || isSubmitting"
					@click="handleSubmit"
				>
					{{ isSubmitting ? 'Submitting...' : 'Confirm' }}
				</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';

export default {
	name: 'ModalOrderDetailECCode',
	components: {
		ModalHeaderWrapper,
	},
	props: {
		isSubmitting: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isShow: false,
			message: null,
		};
	},
	methods: {
		open() {
			this.isShow = true;
			this.message = null;
		},
		close() {
			this.isShow = false;
		},
		async handleSubmit() {
			this.$emit('onConfirm', this.message);
		},
	},
};
</script>
